import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
